"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FootprintVenueDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const VenueListStats_dto_1 = require("./VenueListStats.dto");
const VenueSearchItem_dto_1 = require("./VenueSearchItem.dto");
/** One My Footprint row: the venue search payload plus activity stats and the user's latest visit. */
class FootprintVenueDto extends VenueSearchItem_dto_1.VenueSearchItemDto {}
exports.FootprintVenueDto = FootprintVenueDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: () => VenueListStats_dto_1.VenueListStatsDto
}), __metadata("design:type", VenueListStats_dto_1.VenueListStatsDto)], FootprintVenueDto.prototype, "stats", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "The user's most recent visible check-in at this venue (ISO)."
}), __metadata("design:type", String)], FootprintVenueDto.prototype, "lastVisitedAt", void 0);
//# sourceMappingURL=FootprintVenue.dto.js.map